/* Archive: quiet cards and shops that left.
 *
 * No artboard draws it; the words are B5's own and unchanged. It is drawn in
 * the light register as rows rather than cards, because nothing here is
 * waiting to be walked to. Nothing is deleted from it.
 */
import { t } from "@damga/kit";

import type { Card } from "../App";

function held(card: Card): string {
  if (card.program_type === "points") return t("archive.points", "en", { n: card.balance });
  return `${card.balance} / ${card.threshold}`;
}

export function Archive({ cards, onBack }: { cards: Card[]; onBack: () => void }) {
  const anyDormant = cards.some((c) => c.status !== "closed");
  return (
    <>
      <button type="button" className="back" onClick={onBack}>
        ← {t("archive.back")}
      </button>
      {cards.length === 0 ? (
        <div className="empty">
          <p className="empty-title">{t("archive.empty.title")}</p>
          <p className="empty-body">{t("archive.empty.body")}</p>
        </div>
      ) : (
        <>
          <div>
            <h2 className="display">{t(anyDormant ? "archive.title" : "archive.closedOnly.title")}</h2>
            <p className="lead">{t(anyDormant ? "archive.body" : "archive.closedOnly.body")}</p>
          </div>
          <ul className="rows">
            {cards.map((card) => (
              <li className="row" key={card.membership_id}>
                <span className="dot" data-kind="quiet" aria-hidden="true">
                  {card.business_name.slice(0, 1).toUpperCase()}
                </span>
                <div className="row-main">
                  <p className="row-title">{card.business_name}</p>
                  {card.status === "closed" && <p className="row-meta">{t("archive.closed")}</p>}
                </div>
                <span className="row-value">{held(card)}</span>
              </li>
            ))}
          </ul>
          <p className="fine">{t("archive.footer")}</p>
        </>
      )}
    </>
  );
}
